import React from "react";
import { TestingLevelType } from "types/retest-task";
import { useNavigate } from "react-router-dom";
import _truncate from "lodash/truncate";
import ROUTES from "constants/routes";
import { Text } from "components/core";
import { Box, Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import RemoveIcon from "@mui/icons-material/Remove";
import InfoIcon from "@mui/icons-material/Info";

// interface TestingLevelProps extends Omit<TestingLevelType, "id">

export const TestingLevelStatus = {
  WARNING: "warning",
  ACTIVE: "active",
};

function TestingLevel({
  isCheck = false,
  level,
  content,
  linkedPrimeId,
  linkedPrimeWicNumber,
  status,
  disabled = false,
  isLineLinkedPrimeWicNumber = false,
}: Omit<TestingLevelType, "id">) {
  const navigate = useNavigate();

  let TextLevelStatusColor = "";
  switch (status) {
    case TestingLevelStatus.WARNING:
      TextLevelStatusColor = "#FF870E";
      break;
    case TestingLevelStatus.ACTIVE:
      TextLevelStatusColor = "#0DA16C";
      break;
    case "default":
    default:
      TextLevelStatusColor = "#404040";
      break;
  }

  const TextLevelColor = disabled ? "#BFBFBF" : TextLevelStatusColor;

  const handleClickLevel = (e: any) => {
    e.stopPropagation();
    if (!linkedPrimeId) return;
    // navigate(`${ROUTES.SKU_PROFILE}/${linkedPrimeId}`);
    window.open(`${ROUTES.SKU_PROFILE}/${linkedPrimeId}`, "_blank");
  };

  const isShowTooltip = !(status === TestingLevelStatus.ACTIVE && isCheck) && content;

  return (
    <Box
      flex={1}
      sx={{
        padding: "4px",
        borderRadius: "4px",
        "&:hover": {
          cursor: linkedPrimeId ? "pointer" : "default",
          background: linkedPrimeId ? "#E6E6E6" : "none",
          "& .underline-text": {
            // Assuming the Text component has a className of "text"
            textDecoration: "underline",
          },
        },
      }}
      onClick={handleClickLevel}
    >
      <Tooltip title={isShowTooltip ? content : undefined} placement="top">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          color={status === "active" ? "#B0D400" : TextLevelColor}
        >
          {isCheck ? <DoneIcon /> : <RemoveIcon />}
          <Text
            sx={{ color: TextLevelColor, fontSize: "16px !important", padding: "4px 2px 4px 4px" }}
            bold
          >
            {level}
          </Text>
          {isShowTooltip && <InfoIcon sx={{ color: TextLevelColor, fontSize: 12 }} />}
        </Box>
      </Tooltip>

      <Text
        display="flex"
        justifyContent="center"
        className="underline-text"
        sx={{
          fontSize: "8px !important",
          color: "#808080",
          visibility: disabled || !linkedPrimeWicNumber || isCheck ? "hidden" : "initial",
          textAlign: isLineLinkedPrimeWicNumber ? "left" : "center",
          wordBreak: "break-all",
          paddingLeft: isLineLinkedPrimeWicNumber ? "3px" : "0",
          borderLeft: isLineLinkedPrimeWicNumber ? `3px solid ${TextLevelColor}` : "none",
        }}
      >
        {/*{_truncate(linkedPrimeWicNumber, { length: 12 })}*/}
        {linkedPrimeWicNumber}
      </Text>
    </Box>
  );
}

export default TestingLevel;
